import GeneralHeroSection from "../generalHeroSection";
import HorizontalSectionCard from "../../general/horizontalSectionCard";
import Button from "../../general/ui-blocks/elements/button";
import NoImageSectionCard from "../../general/noImageSectionCard";
import {StartupTrainerImage, StartupTrainerOnStage} from "../../../assets";
import Accordion from "../../general/ui-blocks/elements/accordion";
import {motion} from "motion/react";


export default function TrainerBodyComponent(props) {

    /*

     */

    /*
        TODO - Other:
            Form
                2. Add what makes a good leader/good startup.
                3. Which program they are applying to.
                4. Essay
                5. If they need financial aid. Don't ask this, just put a note that sends them to the financial aid form. Tell them to use the same email.

        TODO:
            Admissions
                1. Interview process.
                2. Once you submit your application, it will be reviewed on a rolling basis.
                3. You will hear back from us within 2-4 weeks about next steps. Regardless if you are accepted or rejected.
                4. Parents will be able to meet with the team and the Startup Trainer once the student is approved.
                5. If you have any further questions, you can fill out the contact us form on the contact us page.
                6.

     */

    return (
        <div>


            <GeneralHeroSection
                title="Startup Trainer"
                blurb="It costs too much to be an innovator, when the road has already been paved."
                imageURL={StartupTrainerImage}
                imageAlt="Startup Trainer Banner Image 1"/>

            <div className="container">
                <div className="container mb-4">
                    <NoImageSectionCard
                        title={<strong><h3>
                            Guidance Every Step of the Way
                        </h3></strong>}
                        blurb={<div className="space-y-4">
                            <p>
                                Your trainer knows what it’s like to start from zero, because they’ve done it
                                themselves.
                                They’ve invested countless years and learned the hard way
                                what works and what doesn’t. Now, they’re here to help you build your startup, while teaching you
                                how to dodge the unnecessary pitfalls.
                            </p>
                        </div>}

                        primaryButtonRow={
                            <Button text="START YOUR APPLICATION" ctaURL={"/apply"}
                                    variant="btn-secondary"/>
                        }
                    />

                </div>

                <HorizontalSectionCard
                    title={<div id="" className="text-2xl md:text-4xl lg:text-5xl"><strong>The Principal</strong></div>}
                    blurb={
                        <div>
                            <p className="mb-2">
                                It costs too much to be an innovator, when the road has already been paved.

                                The Startup Trainer is the person guiding your team. It is a priority that this person
                                has
                                heavy experience of success in the startup space, thus, we have set high standards for
                                them to
                                join an Extern Academy team:
                            </p>

                            <ol className="space-y-2 list-decimal list-inside">
                                <li>
                                    <strong className="brand-color">Taken a consumer product from 0 to 1:</strong>{" "}
                                    Our Startup Trainers have built something from nothing and launched it into the
                                    world, navigating the full startup lifecycle.
                                </li>
                                <li>
                                    <strong className="brand-color">Raised over $1 million:</strong>{" "}
                                    Each trainers has raised over
                                    $1 million in capital funding from angel investors and venture capitalists.
                                </li>
                                <li>
                                    <strong className="brand-color">Served more than 100,000 users:</strong>{" "}
                                    Trainers have built something people actually needed and grew it to scale. This
                                    proves the trainer
                                    has as good grasp of building for product-market fit.
                                </li>
                            </ol>
                        </div>
                    }
                    imageDirection="right"
                    primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/63fd8610e5ff623d7e3e11b6_leaders.webp"
                    primaryImageALT="Paypal Mafia Team Image"
                />

                <HorizontalSectionCard
                    title={<div id="" className="text-2xl md:text-4xl lg:text-6xl"><strong>A Guide from the <span
                        className="brand-color">Trenches</span></strong></div>}
                    blurb={
                        <div>
                            <p className="mb-2">
                                Startup Trainers wear multiple hats across product, engineering, marketing, and finance.
                                They’ve thrived in the competitive capitalistic markets. Whether they’re currently
                                running a company or a seasoned veteran who has stepped back to guide the next
                                generation, they bring hard‑won clarity to every conversation, distilling complex ideas
                                into actionable insights. Deeply connected in the US and international startup
                                ecosystems, our Startup Trainers have been through elite accelerators like Y Combinator,
                                Techstars, and 500 Global.
                            </p>
                        </div>
                    }
                    imageDirection="left"
                    primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/editorial/img_2848-640x400.webp"
                    primaryImageALT="Startup Trainer Two-Man Team Image"
                    secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/editorial/12relationship-project-01-kvbj-mediumsquareat3x.webp"
                    secondaryImageShouldMaxHeight={false}
                    secondaryImageALT="Startup Trainer Image"
                    primaryButtonRow={
                        <div className="row flex-wrap mx-n2">
                            <Button text="ADMISSIONS CHECKLIST"
                                    ctaURL={"/admissions"}
                                    target="_blank"/>
                        </div>
                    }
                />

                <HorizontalSectionCard
                    title={<div id="" className="text-2xl md:text-4xl lg:text-6xl"><strong>How to Stay{" "}<span className="brand-color">Connected</span>{" "}Beyond Demo Day</strong></div>}
                    blurb={
                        <div className="space-y-4">
                            <p className="">
                                Your work with the Startup Trainer doesn’t end at demo day. What begins as a guiding
                                hand through the build evolves into a lasting professional relationship, one you can
                                draw on for years to come.
                            </p>
                            <p>
                                Whether you’re navigating a critical decision or seeking a letter
                                of recommendation that speaks to your real capabilities, your trainer remains a
                                resource. Many alumni continue to consult their trainers long after the cohort,
                                leveraging their insight and networks as they move into college and diverse career paths.
                            </p>
                        </div>
                    }
                    imageDirection="left"
                    primaryImageURL={StartupTrainerOnStage}
                    primaryImageALT="Startup Trainer On Stage"
                    secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/editorial/deeligencefounders_01869-640x400.webp"
                    secondaryImageALT=""
                    // primaryButtonRow={
                    //     <div className="row flex-wrap mx-n2">
                    //         <Button text="ADMISSIONS CHECKLIST"
                    //                 ctaURL={"/admissions"}
                    //                 target="_blank"/>
                    //     </div>
                    // }
                />





                <NoImageSectionCard shouldRemovePatternWrap={false}/>

                <div id="applicationessentials"
                     className="bg-gray-100 theme-dark bg-color bg-pattern-full-width bg-pattern _none mt-5 mb-20">
                    <NoImageSectionCard
                        title={<h2 className="mb-5 text-center text-3xl md:text-5xl lg:text-6xl"><strong>Application
                            Essentials</strong></h2>} shouldRemovePatternWrap={true}/>


                    <Accordion title="How are Startup Trainers selected?" blurb={
                        <div className="space-y-4">
                            <p>
                                We vet each trainer personally. We look for founders who have built a consumer product
                                from zero to launch, raised institutional capital, and scaled to meaningful user
                                numbers. Beyond credentials, we evaluate their ability to mentor, communicate clearly,
                                and guide young builders. Every trainer is someone we would trust with our own team.
                            </p>
                        </div>
                    }/>
                    <Accordion
                        title="Will I get direct access to the trainer?"
                        blurb={
                            <div className="space-y-4">
                                <p>
                                    Yes. Your trainer is present at every standup (three times per week) and is
                                    available for questions via Slack between meetings. They are an active member of
                                    your team, there to guide decisions and help progress.
                                </p>
                            </div>

                        }/>
                    <Accordion
                        title="Are trainers available for 1‑on‑1 coaching?"
                        blurb={
                            <div className="space-y-4">
                                <p>
                                    While the primary interaction is with the full team, trainers are accessible via
                                    Slack for quick questions. If you need deeper 1‑on‑1 time, you can request a short
                                    session, and the trainer will accommodate based on availability.
                                </p>
                            </div>
                        }/>
                    <Accordion
                        title="Can I stay in touch with my trainer after the program?"
                        blurb={
                            <div className="space-y-4">
                                <p>
                                    Yes. Many students maintain relationships with their trainers well beyond the
                                    cohort. Trainers are often happy to provide ongoing advice, write letters of
                                    recommendation, or make introductions to their networks. You’ll leave with a trusted
                                    advisor in your corner.
                                </p>
                            </div>
                        }/>

                </div>

            </div>
        </div>
    )
}